import React, { useEffect, useState } from "react";
import Header from "./Header";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const Docs = () => {
  useEffect(() => {
    sessionStorage.clear();
    localStorage.clear();
  }, []);

  const [where, setWhere] = useState(1);
  const navigate = useNavigate();

  return (
    <>
      <HomeContainer>
        <Header />
        <BasicInfoContainer>
          <LeftMenu>
            <h2>자료실</h2>
            {where === 1 ? (
              <>
                <RedTap>
                  <MenuTap onClick={() => setWhere(1)}>
                    <strong>사용자 가이드</strong>
                  </MenuTap>
                </RedTap>
              </>
            ) : (
              <>
                <BlackTap>
                  <MenuTap onClick={() => setWhere(1)}>사용자 가이드</MenuTap>
                </BlackTap>
              </>
            )}
            {where === 2 ? (
              <>
                <RedTap>
                  <MenuTap onClick={() => setWhere(2)}>
                    <strong>튜토리얼</strong>
                  </MenuTap>
                </RedTap>
              </>
            ) : (
              <>
                <BlackTap>
                  <MenuTap onClick={() => setWhere(2)}>튜토리얼</MenuTap>
                </BlackTap>
              </>
            )}
          </LeftMenu>
          <TextContainer>
            {where === 1 && (
              <>
                <PageTitle>사용자 가이드</PageTitle>
                <RedLine></RedLine>
                <FlexRow>
                  <TextBox>
                    <Explain>
                      RAPVI 제작자 측에서는 사용자들의 RAPVI 사용을 돕기 위해
                      매뉴얼, 사용자 가이드를 제공하고 있습니다.
                    </Explain>
                    <ul>
                      <li>
                        <Explain>
                          RAPVI 매뉴얼: 프로그램 주요 기능, 사용 방법, 기술 문서
                          및 수식 등 RAPVI 관련 정보를 정리하여 pdf 형태로
                          제공하고 있습니다.
                        </Explain>
                      </li>
                      <li>
                        <Explain>
                          RAPVI 사용자 가이드: 사용자의 수월한 프로그램 사용을
                          돕기 위해 각 평가 및 단계 진행 방법 및 설명을 ppt
                          형태로 제공하고 있습니다.
                        </Explain>
                      </li>
                    </ul>
                    <Explain>
                      또한 부지 기반 평가를 진행 시, 오염 부지의 공간 분포
                      특성을 위해성 계산에 반영하려면 수평 혹은 수직적 공간
                      분포를 수치적으로 그리드에 입력해야 합니다.{" "}
                    </Explain>
                    <Explain>
                      이 과정을 돕기 위해 RAPVI 제작자 측에서는 전 처리 문서를
                      제공하고 있습니다.
                    </Explain>
                    <Explain>
                      전 처리 문서는 ‘부지 기반 평가 시 입력 값의 그리드화’와
                      ‘부지 기반 평가 시 다중 지층에서의 확산 계수 계산’으로
                      구성되어 있습니다.
                    </Explain>
                    <Explain>
                      아래 링크를 통해 RAPVI 매뉴얼, 사용자 가이드, 입력 전 처리
                      문서를 확인할 수 있습니다.
                    </Explain>

                    <GuideLink
                      onClick={() =>
                        window.open(
                          "https://docs.google.com/presentation/d/1J1dtYnPnG7OTtm18ixwL-5pzql4ZHltf/edit?usp=share_link&ouid=100870610785043714305&rtpof=true&sd=true"
                        )
                      }
                    >
                      RAPVI 프로그램 관련 문서
                    </GuideLink>
                  </TextBox>
                </FlexRow>
              </>
            )}
            {where === 2 && (
              <>
                <PageTitle>튜토리얼</PageTitle>
                <RedLine></RedLine>
                <FlexRow>
                  <div>
                    <Explain>
                      사용자가 실제로 증기침입 위해성 평가를 진행하기 전,
                      튜토리얼을 우선 진행할 수 있습니다.
                    </Explain>
                    <Explain>
                      본 튜토리얼의 수치 값들은 제작자 측에서 입력 한 값이며,
                      사용자의 전체적인 RAPVI 프로그램의 흐름 체험 및 입력/결과
                      값의 예시 확인을 돕는 것을 주 목적으로 제작하였습니다.
                    </Explain>
                    <Explain>
                      튜토리얼은 아래 링크를 통해 진행할 수 있습니다.
                    </Explain>
                    <GuideLink onClick={() => navigate("/tutorial")}>
                      RAPVI 튜토리얼 시작하기
                    </GuideLink>
                  </div>
                </FlexRow>
              </>
            )}
          </TextContainer>
        </BasicInfoContainer>
      </HomeContainer>
    </>
  );
};

export default Docs;

// 전체 컨테이너
const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`;

// 연구진 정보
const Person = styled.div`
  margin: 2rem 0.5rem;
`;

const Part = styled.p`
  font-size: 1.1rem;
  font-weight: 700;
`;
const Name = styled.p`
  font-size: 1.3rem;
  font-weight: 700;
`;
const Mail = styled.p`
  font-size: 1rem;
`;

// 왼쪽 메뉴
const LeftMenu = styled.div`
  margin: 3rem 5rem;
  width: 22%;
`;

const RedTap = styled.div`
  border-left: 0.5rem solid rgb(141, 0, 42);
  border-top: 1px solid black;
  border-bottom: 1px solid black;
`;

const BlackTap = styled.div`
  border-top: 1px solid black;
  border-bottom: 1px solid black;
`;

const MenuTap = styled.p`
  font-size: 1rem;
  &:hover {
    cursor: pointer;
  }
  margin-left: 0.7rem;
`;

// 왼쪽 메뉴 & 오른쪽 정보 flex box
const BasicInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

// 오른쪽정보
const TextContainer = styled.div`
  margin: 3.5rem 5rem 3rem 0rem;
  width: 70%;
`;

const PageTitle = styled.p`
  font-size: 1.5rem;
  font-weight: 700;
`;

const SubTitle = styled.p`
  font-size: 1.2rem;
  font-weight: 700;
  margin-top: 3rem;
  margin-left: 1rem;
`;

const Explain = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  margin-left: 1rem;
`;
const RedLine = styled.div`
  border: solid 0.2rem rgb(141, 0, 42);
  height: 0;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const GuideLink = styled.p`
  text-decoration: underline;
  font-size: 0.9rem;
  font-weight: 500;
  margin-left: 1rem;
  &:hover,
  &:focus {
    color: blue;
    cursor: pointer;
  }
`;

// 평가 방식 비교
const Box = styled.div`
  border: 0.4rem solid rgb(224, 214, 198);
  border-radius: 20% 20%;
  margin: 1rem;
  padding: 1rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
`;

const HorizontalLine = styled.div`
  border-bottom: 0.3rem solid rgb(224, 214, 198);
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
`;

const TextBox = styled.div`
  margin-right: 1rem;
`;

const VideoBox = styled.div`
  margin: 3rem 2rem;
`;

const HomeImg = styled.img`
  width: 17rem;
  object-fit: contain;
  margin: 0rem 3rem;
`;
